export default __webpack_public_path__ + "static/media/dashboard.4e10d73a.jpg";